/**
 * Formats the fractional number part of the number.
 * @param value A value representing the fractional part of the number to be formatted
 * @param removeTrailingZeros Enables no decimal zeros to be displayed
 * @returns Formatted fractional number part
 */
export function formatFractionalPart(value, removeTrailingZeros = false) {
  // No value is given. There is nothing to solve. Returns the given value.
  if (!value) {
    return value;
  }
  if (removeTrailingZeros) {
    return value.replace(/0+$/, '');
  }
  return value;
}
//# sourceMappingURL=formatFractionalPart.js.map